import moment from '@g4/moment-utc';
import { RETURNING } from '../../constants';

const datesWithLowFares = (
  leg,
  oppositeLegSelection,
  flightOptions,
  lowFares,
  middleTabDate,
  oppositeSelectedTabDate,
  extraDays
) => {
  const minReturnDate =
    oppositeSelectedTabDate ||
    moment(oppositeLegSelection?.flight.departingTime, 'YYYY-MM-DD').format(
      'YYYY-MM-DD'
    );

  const startingDate =
    leg === RETURNING &&
    moment(middleTabDate)
      .subtract(extraDays, 'days')
      .isBefore(moment(minReturnDate, 'YYYY-MM-DD'))
      ? moment(minReturnDate, 'YYYY-MM-DD')
      : moment(middleTabDate).subtract(extraDays, 'days');

  const endingDate =
    leg === RETURNING &&
    moment(middleTabDate)
      .subtract(extraDays, 'days')
      .isBefore(moment(minReturnDate, 'YYYY-MM-DD'))
      ? moment(startingDate).add(extraDays * 2, 'days')
      : moment(middleTabDate).add(extraDays, 'days');

  const range = endingDate.diff(startingDate, 'days') + 1;
  const lowFareDates = Array.from({ length: range }, (_, index) =>
    moment(startingDate)
      .add(index, 'days')
      .format('YYYY-MM-DD')
  );

  // Group attach low-fares and flights to each date
  const lowFareDateMap = lowFares.reduce((date, lowFare) => {
    const lowFareDate = moment(lowFare.date).format('YYYY-MM-DD');
    if (!lowFareDates.includes(lowFareDate)) {
      return date;
    }
    const sortedFlightsForDate = flightOptions
      .filter(flight => moment(flight.flight.departingTime).format('YYYY-MM-DD') === lowFareDate)
      .sort((a, b) => moment(a.flight.departingTime).diff(moment(b.flight.departingTime)));

    date[lowFareDate] = {
      fare: lowFare.fare,
      flights: sortedFlightsForDate
    };
    return date;
  }, {})

  // Set rendered tabs with the included tabs
  const dateTabData = {};
  for (const date of lowFareDates) {
    dateTabData[date] = lowFareDateMap[date]
  }

  return dateTabData;
};

export default datesWithLowFares;
